module.exports = __webpack_public_path__ + "static/img/bonus_8.ad19530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/bonus_8.png
// module id = iN5I
// module chunks = 0